<template>
  <div class="chat-bubble">
    <i @click="updateShowChat">
      <img src="../../assets/icons/chat.svg" class="chat-icon-img" />
    </i>
  </div>
</template>

<script setup>
import { computed } from "vue";
import store from "../../store/index";

const showChat = computed({
  get: () => store.state.chat.showChat,
});

const updateShowChat = () => {
  store.commit("chat/updateShowChat", !showChat.value);
};
</script>
